/* LUNORA — cart savings/reservation helper.
   The free-shipping banner is static in
   Liquid/CSS; this file only preserves the existing reservation timer and
   savings amount across Shopify cart re-renders. */

(function () {
  var TIMER_DURATION_MS = 6 * 60 * 1000;
  var STORAGE_KEY = 'lunoraCartReservationStart';
  var timerInterval = null;
  var activeStartTime = null;

  function formatTime(ms) {
    var totalSeconds = Math.max(0, Math.ceil(ms / 1000));
    var minutes = Math.floor(totalSeconds / 60);
    var seconds = totalSeconds % 60;
    return (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
  }

  function hasCartItems() {
    var drawer = document.querySelector('cart-drawer');
    return !!drawer && !drawer.classList.contains('is-empty') && !!document.getElementById('LunoraUnlockedStage');
  }

  function stopTimer() {
    if (timerInterval) {
      clearInterval(timerInterval);
      timerInterval = null;
    }
    activeStartTime = null;
  }

  function startOrResumeTimer() {
    var timerEl = document.getElementById('LunoraReservedTimer');
    if (!timerEl) return;

    if (!hasCartItems()) {
      sessionStorage.removeItem(STORAGE_KEY);
      stopTimer();
      return;
    }

    var now = Date.now();
    var storedStart = parseInt(sessionStorage.getItem(STORAGE_KEY), 10);

    if (!storedStart || isNaN(storedStart) || now - storedStart >= TIMER_DURATION_MS) {
      storedStart = now;
      sessionStorage.setItem(STORAGE_KEY, String(storedStart));
    }

    if (timerInterval && activeStartTime === storedStart) return;

    stopTimer();
    activeStartTime = storedStart;

    function tick() {
      var el = document.getElementById('LunoraReservedTimer');
      if (!el) {
        stopTimer();
        return;
      }

      var remaining = TIMER_DURATION_MS - (Date.now() - activeStartTime);
      if (remaining <= 0) {
        el.textContent = '00:00';
        stopTimer();
        return;
      }

      el.textContent = formatTime(remaining);
    }

    tick();
    timerInterval = setInterval(tick, 1000);
  }

  function normalizeSavings() {
    var savingsEl = document.getElementById('LunoraSavingsNumber');
    var panel = document.getElementById('LunoraUnlockedStage');
    if (!savingsEl || !panel) return;

    var rawSavings = panel.getAttribute('data-savings-amount') || '0';
    var savingsTarget = parseFloat(rawSavings.replace(/,/g, '')) || 0;
    var currencySymbol = panel.getAttribute('data-currency-symbol') || '$';

    if (savingsTarget <= 0) {
      savingsEl.textContent = currencySymbol + '0.00';
    }
  }

  function syncQuantityStates() {
    var quantities = document.querySelectorAll('cart-drawer quantity-input.cart-quantity');
    for (var i = 0; i < quantities.length; i++) {
      var input = quantities[i].querySelector('.quantity__input');
      var value = input ? parseInt(input.value, 10) : 1;
      quantities[i].classList.toggle('lunora-qty-is-one', !value || value <= 1);
    }
  }

  function runLunoraCartBanner() {
    normalizeSavings();
    startOrResumeTimer();
    syncQuantityStates();
  }

  document.addEventListener('cart:open', runLunoraCartBanner);
  document.addEventListener('cart:updated', runLunoraCartBanner);
  document.addEventListener('sections:load', runLunoraCartBanner);
  document.addEventListener('section:load', runLunoraCartBanner);
  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('cart-drawer .quantity__input')) {
      syncQuantityStates();
    }
  });
  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest('cart-drawer .quantity__button')) {
      window.setTimeout(syncQuantityStates, 0);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    runLunoraCartBanner();

    var drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length > 0) {
          runLunoraCartBanner();
          break;
        }
      }
    });

    observer.observe(drawerEl, { childList: true, subtree: true });
  });
})();
